import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {IMPCountryDetailListItem, IMPFaqModule} from "../marketing-page.models";
import {LoggerService} from "../../common/logger.service";
import {MarketingPageUtil} from "../marketing-page-util";

@Component({
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FaqComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPFaqModule;
    useLocaleOverride: boolean;
    translationRoot: string;
    textStyle: string;
    backgroundColor: string;
    currentExpandedId: number;
    questions: IMPCountryDetailListItem[];

    constructor(loggerService: LoggerService) {
        super(loggerService);
    }

    ngOnInit(): void {
        this.setFaqAttributes();
    }

    toggleExpand(id: number) {
        if (this.isExpanded(id)) {
            this.currentExpandedId = undefined;
        } else {
            this.currentExpandedId = id;
        }
    }

    isExpanded(id: number): boolean {
        return this.currentExpandedId == id;
    }

    setFaqAttributes() {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.questions = this.componentData.countryDetails[0].listItems;
        this.questions.sort((a, b) => a.listItemOrder - b.listItemOrder); // we can't guarantee the order this will be returned in, so let's sort it
    }
}
